var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutoGeneratedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85414 2.24547C10.4958 1.70464 11.5316 1.70464 12.155 2.24547L13.6033 3.48297C13.8783 3.71214 14.4008 3.90464 14.7675 3.90464H16.3258C17.2975 3.90464 18.095 4.70214 18.095 5.6738V7.23214C18.095 7.5988 18.2875 8.11214 18.5166 8.38714L19.7541 9.83547C20.295 10.4771 20.295 11.513 19.7541 12.1363L18.5166 13.5846C18.2875 13.8596 18.095 14.373 18.095 14.7396V16.298C18.095 17.2696 17.2975 18.0671 16.3258 18.0671H14.7675C14.4008 18.0671 13.8875 18.2596 13.6125 18.4888L12.1641 19.7263C11.5225 20.2671 10.4866 20.2671 9.86331 19.7263L8.41497 18.4888C8.13997 18.2596 7.61747 18.0671 7.25997 18.0671H5.65581C4.68414 18.0671 3.88664 17.2696 3.88664 16.298V14.7305C3.88664 14.373 3.70331 13.8505 3.47414 13.5846L2.23664 12.1271C1.70497 11.4946 1.70497 10.468 2.23664 9.83547L3.47414 8.37797C3.70331 8.10297 3.88664 7.58964 3.88664 7.23214V5.68297C3.88664 4.7113 4.68414 3.9138 5.65581 3.9138H7.24164C7.60831 3.9138 8.12164 3.7213 8.39664 3.49214L9.85414 2.24547Z",
    fill: "white",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.45312V11.8806",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9941 14.668H11.0024",
    stroke: "#0C80F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoGeneratedIcon);
export default __webpack_public_path__ + "static/media/auto_generated_icon.b179087df04996017f19de0bbc3a9015.svg";
export { ForwardRef as ReactComponent };